import { AttributeIdentifiers } from "@lyfegen-platform/graphql-schema/models";
import { AdministrationDateFieldController } from "../../controllers/administration-date-field-controller";
import { AdverseEventAssessmentDateFieldController } from "../../controllers/adverse-event-assessment-date-field-controller";
import { AdverseEventDoseModificationFieldController } from "../../controllers/adverse-event-dose-modification-field-controller";
import { AdverseEventFieldController } from "../../controllers/adverse-event-field-controller";
import { AdverseEventGradeFieldController } from "../../controllers/adverse-event-grade-field-controller";
import { AssessmentDateFieldController } from "../../controllers/assessment-date-field-controller";
import { BasePriceFieldController } from "../../controllers/base-price-field-controller";
import { BenefitAssessmentDateFieldController } from "../../controllers/benefit-assessment-date-field-controller";
import { BrandNameFieldController } from "../../controllers/brand-name-field-controller";
import { BrandReferenceFieldController } from "../../controllers/brand-reference-field-controller";
import { ClinicalTrialFieldController } from "../../controllers/clinical-trial-field-controller";
import { CoverageEndDateFieldController } from "../../controllers/coverage-end-date-field-controller";
import { CoverageStartDateFieldController } from "../../controllers/coverage-start-date-field-controller";
import { DecisionTherapyFieldController } from "../../controllers/decision-therapy-field-controller";
import { DiagnosisDateFieldController } from "../../controllers/diagnosis-date-field-controller";
import { DiscontinuationDateFieldController } from "../../controllers/discontinuation-date-field-controller";
import { DiscountRateFieldController } from "../../controllers/discount-rate-field-controller";
import { DiseaseFieldController } from "../../controllers/disease-field-controller";
import { FixedFeeAmountFieldController } from "../../controllers/fixed-fee-amount-field-controller";
import { FormChatFieldController } from "../../controllers/form-chat-field-controller";
import { GeneralFieldController } from "../../controllers/general-field-controller";
import { GeneralPatientIdFieldController } from "../../controllers/general-patient-id-field-controller";
import { GenericNameFieldController } from "../../controllers/generic-name-field-controller";
import { IndicationFieldController } from "../../controllers/indication-field-controller";
import { IntendedStartDateFieldController } from "../../controllers/intended-start-date-field-controller";
import { PrimaryInterventionDateRelatedPatientIdFieldController } from "../../controllers/intervention-patient-id-field-controller";
import { InvoiceAmountFieldController } from "../../controllers/invoice-amount-field-controller";
import { LegalEntityFieldController } from "../../controllers/legal-entity-field-controller";
import { MainItemModelFieldController } from "../../controllers/main-item-model-field-controller";
import { MedicalHistoryFieldController } from "../../controllers/medical-history-field-controller";
import { NumberOfPrescriptionsToDateFieldController } from "../../controllers/number-of-prescriptions-to-date-field-controller";
import { PackReferenceFieldController } from "../../controllers/pack-reference-field-controller";
import { PackSizeFieldController } from "../../controllers/pack-size-field-controller";
import { PatientEnrolledInTreatmentFieldController } from "../../controllers/patient-enrolled-in-treatment-field-controller";
import { PrescriptionDateFieldController } from "../../controllers/prescription-date-field-controller";
import { PreviousTherapyFieldController } from "../../controllers/previous-therapy-field-controller";
import { PricePreviewTableController } from "../../controllers/price-preview-table-controller";
import { PrimaryInterventionDateFieldController } from "../../controllers/primary-intervention-date-field-controller";
import { ProceedWithoutReviewController } from "../../controllers/proceed-without-review-controller";
import { ProductIdFieldController } from "../../controllers/product-id-field-controller";
import { ProductNameFieldController } from "../../controllers/product-name-field-controller";
import { RadioButtonFieldController } from "../../controllers/radio-button-field-controller";
import { RatingFieldController } from "../../controllers/rating-field-controller";
import { ReasonForDiscontinuationFieldController } from "../../controllers/reason-for-discontinuation-field-controller";
import { RecurrenceDateFieldController } from "../../controllers/recurrence-date-field-controller";
import { RelatedCasesTableController } from "../../controllers/related-cases-table-controller";
import { RequestReceiptDateFieldController } from "../../controllers/request-receipt-date-field-controller";
import { ResponseAssessmentDateFieldController } from "../../controllers/response-assessment-date-field-controller";
import { ResponseReceivedFieldController } from "../../controllers/response-received-field-controller";
import { ResponsiblePhysicianAliasFieldController } from "../../controllers/responsible-physician-alias-field-controller";
import { ResultFieldController } from "../../controllers/result-field-controller";
import { ScopeIdFieldController } from "../../controllers/scope-id-field-controller";
import { SecondaryInterventionDateFieldController } from "../../controllers/secondary-intervention-date-field-controller";
import { SuggestedDiscountRateFieldController } from "../../controllers/suggested-discount-rate-field-controller";
import { SupportingItemModelFieldController } from "../../controllers/supporting-item-model-field-controller";
import { TherapyStartDateFieldController } from "../../controllers/therapy-start-date-field-controller";
import { TherapyTrialEndDateFieldController } from "../../controllers/therapy-trial-end-date-field-controller";
import { TherapyTrialStartDateFieldController } from "../../controllers/therapy-trial-start-date-field-controller";
import { TimeframeFieldController } from "../../controllers/timeframe-field-controller";
import { TreatingPhysicianDepartmentFieldController } from "../../controllers/treating-physician-department-field-controller";
import { TreatingPhysicianEmailFieldController } from "../../controllers/treating-physician-email-field-controller";
import { TreatingPhysicianFirstNameFieldController } from "../../controllers/treating-physician-first-name-field-controller";
import { TreatingPhysicianHospitalNameFieldController } from "../../controllers/treating-physician-hospital-name-field-controller";
import { TreatingPhysicianLastNameFieldController } from "../../controllers/treating-physician-last-name-field-controller";
import { TreatingPhysicianNrFieldController } from "../../controllers/treating-physician-nr-field-controller";
import { TreatingPhysicianPhoneNoFieldController } from "../../controllers/treating-physician-phone-no-field-controller";
import { TreatingPhysicianPlaceFieldController } from "../../controllers/treating-physician-place-field-controller";
import { TreatingPhysicianPostcodeFieldController } from "../../controllers/treating-physician-postcode-field-controller";
import { TreatingPhysicianStreetFieldController } from "../../controllers/treating-physician-street-field-controller";
import { TreatingPhysicianTitleFieldController } from "../../controllers/treating-physician-title-field-controller";
import { TreatmentPackFieldController } from "../../controllers/treatment-pack-field-controller";
import { YearOfBirthFieldController } from "../../controllers/year-of-birth-field-controller";
import { FlexFieldController } from "./flex-field-controller";
import { FlexFieldSchema } from "./flex-field-schema";
import { FlexSectionSchema } from "./flex-section-schema";
import { LdlLevelUoMFieldController } from "./ldl-level-uom-field-controller";
import { InitialsFieldController } from "../../controllers/initials-field-controller";
import { ExternalFormIdFieldController } from "../../controllers/external-form-id-field-controller";
import { RelevantIndicationFieldController } from "../../controllers/relevant-indication-field-controller";
import { AdverseEventTraeFieldController } from "../../controllers/adverse-event-trae-field-controller";
import { TestTypeFieldController } from "../../controllers/test-type-field-controller";
import { TestDatesFieldController } from "../../controllers/test-dates-field-controller";
import { TransfusionTypeFieldController } from "../../controllers/transfusion-type-field-controller";
import { TestUoMFieldController } from "../../controllers/test-uom-field-controller";
import { TestPurposeFieldController } from "../../controllers/test-purpose-field-controller";
import { GeneralDropdownCustomAttributeFieldController } from "../../controllers/general-dropdown-custom-attribute-field-controller";
import { DataType } from "../generated/graphql";
import { GeneralBooleanCustomAttributeFieldController } from "../../controllers/general-boolean-custom-attribute-field-controller";
import { AddedByFieldController } from "../../controllers/added-by-field-controller";

const register: { [K in AttributeIdentifiers]?: { new (field: FlexFieldSchema, path: string): FlexFieldController } } = {
	legalEntity: LegalEntityFieldController,
	initials: InitialsFieldController,
	externalFormId: ExternalFormIdFieldController,
	brandName: BrandNameFieldController,
	genericName: GenericNameFieldController,
	disease: DiseaseFieldController,
	indication: IndicationFieldController,
	yearOfBirth: YearOfBirthFieldController,
	invoiceAmount: InvoiceAmountFieldController,
	requestReceiptDate: RequestReceiptDateFieldController,
	diagnosisDate: DiagnosisDateFieldController,
	intendedStartDate: IntendedStartDateFieldController,
	decisionTherapy: DecisionTherapyFieldController,
	rating: RatingFieldController,
	coverageStartDate: CoverageStartDateFieldController,
	coverageEndDate: CoverageEndDateFieldController,
	therapyTrialStartDate: TherapyTrialStartDateFieldController,
	therapyTrialEndDate: TherapyTrialEndDateFieldController,
	relevantIndication: RelevantIndicationFieldController,
	discontinuationDate: DiscontinuationDateFieldController,
	assessmentDate: AssessmentDateFieldController,
	ldlLevelUom: LdlLevelUoMFieldController,
	previousTherapy: PreviousTherapyFieldController,
	scopeId: ScopeIdFieldController,
	proceedWithoutReview: ProceedWithoutReviewController,
	addedBy: AddedByFieldController,

	// IR
	therapyStartDate: TherapyStartDateFieldController,
	responseAssessmentDate: ResponseAssessmentDateFieldController,
	benefitAssessmentDate: BenefitAssessmentDateFieldController,
	responseReceived: ResponseReceivedFieldController,
	result: ResultFieldController,
	patientEnrolledInTreatment: PatientEnrolledInTreatmentFieldController,
	reasonForDiscontinuation: ReasonForDiscontinuationFieldController,
	numberOfPrescriptionsToDate: NumberOfPrescriptionsToDateFieldController,

	// treating physician
	treatingPhysicianTitle: TreatingPhysicianTitleFieldController,
	treatingPhysicianEmail: TreatingPhysicianEmailFieldController,
	treatingPhysicianFirstName: TreatingPhysicianFirstNameFieldController,
	treatingPhysicianLastName: TreatingPhysicianLastNameFieldController,
	treatingPhysicianStreet: TreatingPhysicianStreetFieldController,
	treatingPhysicianNr: TreatingPhysicianNrFieldController,
	treatingPhysicianPostcode: TreatingPhysicianPostcodeFieldController,
	treatingPhysicianPlace: TreatingPhysicianPlaceFieldController,
	treatingPhysicianPhoneNo: TreatingPhysicianPhoneNoFieldController,
	treatingPhysicianHospitalName: TreatingPhysicianHospitalNameFieldController,
	treatingPhysicianDepartment: TreatingPhysicianDepartmentFieldController,

	// Adverse event
	adverseEvent: AdverseEventFieldController,
	adverseEventGrade: AdverseEventGradeFieldController,
	adverseEventAssessmentDate: AdverseEventAssessmentDateFieldController,
	adverseEventDoseModification: AdverseEventDoseModificationFieldController,
	adverseEventTrae: AdverseEventTraeFieldController,

	// Prescription
	treatmentPack: TreatmentPackFieldController,
	packSize: PackSizeFieldController,
	prescriptionDate: PrescriptionDateFieldController,

	// Record
	productId: ProductIdFieldController,
	productName: ProductNameFieldController,
	administrationDate: AdministrationDateFieldController,
	purchaseDate: AdministrationDateFieldController,

	// Intervention
	lowVoltageZone: RadioButtonFieldController,
	adherenceToProtocol: RadioButtonFieldController,
	ctiLineAblated: RadioButtonFieldController,
	mainItemModel: MainItemModelFieldController,
	primaryInterventionDate: PrimaryInterventionDateFieldController,
	recurrenceDate: RecurrenceDateFieldController,
	responsiblePhysician: ResponsiblePhysicianAliasFieldController,
	secondaryInterventionDate: SecondaryInterventionDateFieldController,
	supportingItemModel: SupportingItemModelFieldController,
	// negotiable attributes
	timeframe: TimeframeFieldController,
	basePrice: BasePriceFieldController,
	discountRate: DiscountRateFieldController,
	//case-by-case
	suggestedDiscountRate: SuggestedDiscountRateFieldController,
	pricePreview: PricePreviewTableController,
	relatedCases: RelatedCasesTableController,
	medicalHistory: MedicalHistoryFieldController,
	clinicalTrial: ClinicalTrialFieldController,
	formChat: FormChatFieldController,
	packReference: PackReferenceFieldController,
	brandNameReference: BrandReferenceFieldController,
	fixedFeeAmount: FixedFeeAmountFieldController,

	// Test Attributes
	testType: TestTypeFieldController,
	testDate: TestDatesFieldController,
	testUoM: TestUoMFieldController,
	transfusionType: TransfusionTypeFieldController,
	transfusionDate: TestDatesFieldController,
	testPurpose: TestPurposeFieldController,
};

export const fieldControllerFactory = (field: FlexFieldSchema, section: FlexSectionSchema, path: string): FlexFieldController => {
	if (field.attribute.customCondition && field.attribute.dataType === DataType.Text) {
		return new GeneralDropdownCustomAttributeFieldController(field, path);
	}

	if (field.attribute.customCondition && field.attribute.dataType === DataType.Boolean) {
		return new GeneralBooleanCustomAttributeFieldController(field, path);
	}

	if (field.attribute.identifier === AttributeIdentifiers.PatientId) {
		if (section.fields.some((f) => f.attribute.identifier === AttributeIdentifiers.PrimaryInterventionDate)) {
			return new PrimaryInterventionDateRelatedPatientIdFieldController(field, path);
		}

		return new GeneralPatientIdFieldController(field, path);
	}

	const constructor = register[field.attribute.identifier as AttributeIdentifiers] || GeneralFieldController;
	return new constructor(field, path);
};
